import { render, staticRenderFns } from "./prodVerm.vue?vue&type=template&id=63b75710&scoped=true"
import script from "./prodVerm.vue?vue&type=script&lang=js"
export * from "./prodVerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b75710",
  null
  
)

export default component.exports